import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { RiskRating } from "../../../../../graphql/supergraphEnums";
import { getAccountTypeLabel } from "../../../../../utils/account_types";
import { RiskRatingBadge } from "../../../../riskRating/RiskRatingBadge";
import { hierarchyNodeCard, hierarchyNodeSubtitle } from "../styles_vanilla.css";
import type { PositionNodeData } from "./types";

export const PositionNodeCard = ({ node }: { node: PositionNodeData }) => {
  const subHeaderItems = [...(node.roles ?? []), getAccountTypeLabel(node.accountType)];
  const showRiskRating = node.riskStatus !== RiskRating.None;

  return (
    <Flex alignItems="center" justifyContent="space-between" className={hierarchyNodeCard}>
      <Flex flexDirection="column">
        <Text variant="strong-md">{node.name}</Text>
        <Flex alignItems="center" gap={Sizes.XS}>
          {subHeaderItems.map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              {index > 0 && (
                <Text variant="regular-sm" className={hierarchyNodeSubtitle}>
                  |
                </Text>
              )}
              <Text variant="regular-sm" className={hierarchyNodeSubtitle}>
                {item}
              </Text>
            </React.Fragment>
          ))}
        </Flex>
      </Flex>
      {showRiskRating && (
        <RiskRatingBadge rating={node.riskStatus} textVariant="strong-sm" iconSize="small" />
      )}
    </Flex>
  );
};
